import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { events } from '../../data/events';
import EventCard from './EventCard';
import EventModal from './EventModal';
import './Events.css';

const Events = () => {
  const { t } = useTranslation();
  const { slug: eventSlugParam } = useParams();
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const upcomingEvents = events.filter(event => {
    // TBA dates are always considered upcoming
    if (event.date === "TBA" || event.date === null || event.date === "") {
      return true;
    }
    const eventDate = new Date(event.date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return eventDate >= today;
  }).sort((a, b) => {
    // TBA dates go to the end
    if (a.date === "TBA" || a.date === null || a.date === "") return 1;
    if (b.date === "TBA" || b.date === null || b.date === "") return -1;
    return new Date(a.date) - new Date(b.date);
  });

  const pastEvents = events.filter(event => {
    const eventDate = new Date(event.date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return eventDate < today;
  }).sort((a, b) => new Date(b.date) - new Date(a.date));

  useEffect(() => {
    if (!eventSlugParam) return;
    const targetEvent = events.find(e => e.slug === eventSlugParam);
    if (!targetEvent) return;
    setSelectedEvent(targetEvent);
    const timer = setTimeout(() => {
      if (sectionRef.current) {
        sectionRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [eventSlugParam]);

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    navigate(`/events/${event.slug}`);
  };

  const handleModalClose = () => {
    setSelectedEvent(null);
    if (eventSlugParam) {
      navigate('/#events', { replace: true });
    }
  };

  return (
    <section className="events section" id="events" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title">{t('events.title')}</h2>
        
        <h3 className="events-subtitle">{t('events.upcoming')}</h3>
        {upcomingEvents.length > 0 ? (
          <div className="events-list">
            {upcomingEvents.map((event) => (
              <EventCard
                key={event.id}
                event={event}
                onClick={() => handleEventClick(event)}
              />
            ))}
          </div>
        ) : (
          <div className="events-empty">
            <p>{t('events.noUpcoming')}</p>
          </div>
        )}

        {pastEvents.length > 0 && (
          <>
            <h3 className="events-subtitle" style={{ marginTop: 'var(--spacing-xl)' }}>
              {t('events.past')}
            </h3>
            <div className="events-list">
              {pastEvents.map((event) => (
                <EventCard
                  key={event.id}
                  event={event}
                  onClick={() => handleEventClick(event)}
                />
              ))}
            </div>
          </>
        )}

        {selectedEvent && (
          <EventModal
            event={selectedEvent}
            onClose={handleModalClose}
          />
        )}
      </div>
    </section>
  );
};

export default Events;

